import React from "react";

const MinusCircle = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-minus-circle"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-minus-circle"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm4,13h-8c-.552,0-1-.448-1-1s.448-1,1-1h8c.552,0,1,.448,1,1s-.448,1-1,1Z" />
    </svg>
  );
};

export default MinusCircle;
